import {
  type FC
} from 'react';
import {
  Stack,
  Button,
} from '@mui/joy';
import {
  PaymentMethods,
  type PaymentMethod,
} from '@entities/payments';

export type TryAgainBlockProps = {
  backupPaymentMethods?: Maybe<Array<PaymentMethod>>;
  onTryAgain?(paymentMethod?: Maybe<PaymentMethod>): void;
};

export const TryAgainBlock: FC<TryAgainBlockProps> = ({
  onTryAgain,
  backupPaymentMethods,
}) => (
  <Stack rowGap={2} width='100%'>
    {backupPaymentMethods && (
      <PaymentMethods
        label='Have you tried using?'
        items={backupPaymentMethods}
        onSelect={onTryAgain}
      />
    )}
    <Button
      fullWidth
      color='primary'
      variant='solid'
      onClick={() => onTryAgain?.()}>
      Try Again
    </Button>
  </Stack>
);